
import React, { useEffect, useRef, useState, useContext } from "react";
import { useMemo } from "react";
import "./HeroSection.css";
import CorePlatform from "./CorePlatform";
import IndustrySection from "./IndustrySection";
import OrderTypes from "./OrderTypes";
import PricingSection from "./PricingSection";
// import AiAssistant from "./AiAssistant";
// import FAQ from "./FAQ";
import { useLoader } from "../../context/LoaderProvider";
import Digitalpresence from "./Digitalpresence";
import axios from "axios";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaEnvelope, FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { color } from "framer-motion";
import Maamaasbusiness from "./Maamaasbusiness";
import CTASection from "./CTASection";
import Footerdata from "./Footerdata";
import Coreservices from "./Coreservices";

// import Aboutmaamaas from "./Aboutmaamaas";

export default function HeroSection() {
    const [navVisible, setNavVisible] = useState(false);
    const containerRef = useRef(null);
    const navigate = useNavigate();
    const { showLoader, hideLoader } = useLoader();
    // ✅ REFS FOR SCROLL
    const homeRef = useRef(null);
    const platformRef = useRef(null);
    const industriesRef = useRef(null);
    const coreservicesRef = useRef(null);
    const subscriptionRef = useRef(null);
    const aiRef = useRef(null);
    const faqRef = useRef(null);
    // const { darkMode, toggleTheme } = useContext(ThemeContext);
    const [selectedVertical, setSelectedVertical] = useState("");
    const [isDemoOpen, setIsDemoOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const openDemoModal = (vertical) => {
        setSelectedVertical(vertical);
        setIsDemoOpen(true);
    };

    const closeDemoModal = () => {
        setIsDemoOpen(false);
    };
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    // ✅ POPUP STATES
    const [showLogin, setShowLogin] = useState(false);
    const [isForgot, setIsForgot] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [email, setEmail] = useState("");
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [banners, setBanners] = useState([]);

    const openLoginModal = () => {
        setIsModalOpen(false);
        setIsLoginModalOpen(true);
    };

    const closeLoginModal = () => setIsLoginModalOpen(false);

    const scrollToCTA = () => {
        faqRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const [loginObj, setLoginObj] = useState({
        userName: "",
        password: "",
    });

    const handleEmailCheck = async (e) => {
        e.preventDefault();
        const email = loginObj.emailId?.trim();

        if (!email) {
            alert("Please enter a valid email.");
            return;
        }

        showLoader();

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/vendor/enquiry/get-email`,
                {
                    params: { emailId: email },
                }
            );

            const vendorData = response.data;

            if (vendorData?.vendorId) {
                localStorage.setItem("vendorId", vendorData.vendorId);
                alert("Email Verified Successfully.");
                navigate("/subscriptionpage");
            } else {
                alert("Vendor not found. Please try again.");
            }
        } catch (error) {
            alert("Failed to check email. Please try again.");
        } finally {
            hideLoader();
        }
    };

    // ✅ SCROLL FUNCTION
    const scrollToSection = (ref) => {
        ref.current?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        setIsSidebarOpen(false); // Close sidebar after clicking a link
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleScroll = () => {
            setNavVisible(container.scrollTop > 50);
        };

        container.addEventListener("scroll", handleScroll);
        return () => container.removeEventListener("scroll", handleScroll);
    }, []);

    // Check if mobile view
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // ================= LOGIN HANDLERS =================

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setLoginObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleResetPassword = async () => {
        if (!email) {
            alert("Please enter your email");
            return;
        }

        setLoading(true);

        try {
            const url = `https://backend.maamaas.com/subscription/api/auth/vendor/reset-password?email=${encodeURIComponent(email)}`;

         
            // Check if URL is valid
            try {
                new URL(url);
            } catch (urlError) {
                console.error("3. Invalid URL:", urlError);
                throw new Error("Invalid URL format");
            }

            // Check network status
            if (!navigator.onLine) {
                console.error("4. Browser is offline");
                throw new Error("No internet connection");
            }

            const response = await fetch(url, {
                method: "PUT",
                headers: { "Accept": "*/*" }
            });

            const responseText = await response.text();

            if (response.ok) {
                alert("✅ " + responseText);
                setIsForgot(false);
                setEmail("");
            } else {
                alert(`Failed (${response.status}): ${responseText}`);
            }
        } catch (error) {
            console.error("❌ Detailed error:", error);
            console.error("❌ Error name:", error.name);
            console.error("❌ Error message:", error.message);
            console.error("❌ Error stack:", error.stack);

            if (error.name === "TypeError" && error.message === "Failed to fetch") {
                alert("CORS or Network error. Check console for details.");
            } else {
                alert(`Error: ${error.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    // const handleLogin = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
    //     setError("");

    //     try {
    //         const url = `https://backend.maamaas.com/subscription/api/auth/login/vendor?identifier=${encodeURIComponent(
    //             loginObj.userName
    //         )}&password=${encodeURIComponent(loginObj.password)}`;

    //         const response = await fetch(url, {
    //             method: "POST",
    //             headers: { Accept: "*/*" },
    //             body: "",
    //         });

    //         const data = await response.json();

    //         if (!response.ok) {
    //             throw new Error(data.message || "Login failed");
    //         }

    //         // ============ STORE LOGIN RESPONSE ============
    //         localStorage.clear();

    //         localStorage.setItem("authToken", data.token || "");
    //         localStorage.setItem("refreshToken", data.refreshToken || "");
    //         localStorage.setItem("role", data.role || "");
    //         localStorage.setItem("customerId", data.customerId || "");

    //         // ================= 🔥 EMPLOYEE ROLE FIX =================
    //         const employeeRole = data.employeeRole || "NOT_AVAILABLE";

    //         localStorage.setItem("employeeRole", employeeRole);
    //         localStorage.setItem("parentId", data.parentId?.toString() || "");

    //         // ========================================================

    //         if (data.role === "ROLE_EMPLOYEE") {
    //             localStorage.setItem("vendorId", data.parentId?.toString() || "");
    //             localStorage.setItem("employeeId", data.vendorId?.toString() || "");

    //         } else {
    //             localStorage.setItem("vendorId", data.vendorId?.toString() || "");

    //         }

    //         if (data.businessModules && data.businessModules.length > 0) {
    //             localStorage.setItem("businessModules", JSON.stringify(data.businessModules));
    //         }
    //         if (data.subModules && data.subModules.length > 0) {
    //             localStorage.setItem("subModules", JSON.stringify(data.subModules));
    //         }

    //         localStorage.setItem("appTypes", JSON.stringify(data.appTypes || []));
    //         localStorage.setItem("subscriptionStatus", data.subscriptionStatus || "");
    //         localStorage.setItem("username", data.username || loginObj.userName);
    //         localStorage.setItem("userType", data.userType || "");
    //         localStorage.setItem("loginResponse", JSON.stringify(data));

    //         // ============ BANNER API ============
    //         const userRole = data.role;
    //         const authToken = data.token;

    //         let bannerVendorId;
    //         if (userRole === "ROLE_EMPLOYEE") {
    //             bannerVendorId = data.parentId;
    //         } else {
    //             bannerVendorId = data.vendorId;
    //         }

    //         try {
    //             const bannerResponse = await fetch(
    //                 `https://backend.maamaas.com/food/api/banner/${bannerVendorId}`,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${authToken}`,
    //                     },
    //                 }
    //             );

    //             if (bannerResponse.ok) {
    //                 const bannerData = await bannerResponse.json();

    //                 localStorage.setItem("companyName", bannerData.companyName || "");
    //                 localStorage.setItem("bannerData", JSON.stringify(bannerData));
    //                 localStorage.setItem("companyLogo", bannerData.companyLogo || "");
    //                 localStorage.setItem("companyBanner", bannerData.companyBanner || "");
    //                 localStorage.setItem("restaurantType", bannerData.Type || "");
    //                 localStorage.setItem("restaurantStatus", bannerData.RestaurentStatus ? "true" : "false");
    //                 localStorage.setItem("ratings", bannerData.Ratings?.toString() || "");
    //                 localStorage.setItem("fullAddress", bannerData.fullAddress || "");
    //                 localStorage.setItem("city", bannerData.city || "");
    //                 localStorage.setItem("state", bannerData.state || "");
    //                 localStorage.setItem("pincode", bannerData.pincode?.toString() || "");
    //                 localStorage.setItem("latitude", bannerData.latitude?.toString() || "");
    //                 localStorage.setItem("longitude", bannerData.longitude?.toString() || "");
    //                 localStorage.setItem("orderTypes", JSON.stringify(bannerData.orderTypes || []));
    //                 localStorage.setItem("whatsappLink", bannerData.whatsappLink || "");
    //                 localStorage.setItem("instagramLink", bannerData.instagramLink || "");
    //                 localStorage.setItem("facebookLink", bannerData.facebookLink || "");
    //                 localStorage.setItem("twitterLink", bannerData.twitterLink || "");

    //             } else {
    //                 //console.warn("⚠️ Banner API failed with status:", bannerResponse.status);
    //             }
    //         } catch (bannerError) {
    //             //console.error("❌ Error fetching banner data:", bannerError);
    //         }

    //         // ============ NAVIGATION ============
    //         let redirectPath = "";

    //         if (userRole === "ROLE_EMPLOYEE") {
    //             const businessModules = data.businessModules || [];

    //             const moduleToRoute = {
    //                 "DASHBOARD": "/fooddashboard",
    //                 "BUSINESS_PROFILE": "/foodbeveragescompany",
    //                 "SETTINGS_CONTROLS": "/foodsettings",
    //                 "PRODUCTS_PRICES": "/foodandbeveragesMenu",
    //                 "ORDER_MANAGEMENT": "/foodordermanagment",
    //                 "CHEF_MANAGEMENT": "/foodchefmanagment",
    //                 "SERVICE_MANAGEMENT": "/fooddelivarymanagment",
    //                 "INVENTORY": "/foodandbeveragesInvetory",
    //                 "TEAM_MANAGEMENT": "/teammanagment",
    //                 "SALES_MANAGEMENT": "/salesmanagment",
    //                 "FINANCE_ACCOUNTING": "/foodAccuontdata",
    //                 "PROMOTIONS_MARKETING": "/foodandbeveragespromotions",
    //                 "REFER_EARN": "/referandearn",
    //                 "REWARDS_COUPONS": "/rewardslanding",
    //                 "RATINGS_REVIEWS": "/foodratings",
    //                 "HELP_DESK": "/foodandbeveragessupportsystem",
    //                 "LEGAL_COMPLIANCE": "/foodsupportsystem",
    //                 "NOTIFICATIONS": "/notificationcontext",
    //                 "REPORTS_ANALYSIS": "/foodandreporanalysis",
    //             };

    //             const firstModule = businessModules[0];

    //             if (firstModule && moduleToRoute[firstModule]) {
    //                 redirectPath = moduleToRoute[firstModule];
    //             } else {
    //                 redirectPath = "/fooddashboard";
    //             }

    //         } else {
    //             redirectPath = "/fooddashboard";
    //         }

    //         navigate(redirectPath);

    //     } catch (err) {
    //         //console.error("❌ Login error:", err);
    //         setError("Login failed: " + err.message);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };



    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const url = `https://backend.maamaas.com/subscription/api/auth/login/vendor?identifier=${encodeURIComponent(
                loginObj.userName
            )}&password=${encodeURIComponent(loginObj.password)}`;

            const response = await fetch(url, {
                method: "POST",
                headers: { Accept: "*/*" },
                body: "",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Login failed");
            }

            // ============ STORE LOGIN RESPONSE ============
            localStorage.clear();

            localStorage.setItem("authToken", data.token || "");
            localStorage.setItem("refreshToken", data.refreshToken || "");
            localStorage.setItem("role", data.role || "");
            localStorage.setItem("customerId", data.customerId || "");

            // ================= EMPLOYEE ROLE FIX =================
            const employeeRole = data.employeeRole || "NOT_AVAILABLE";
            localStorage.setItem("employeeRole", employeeRole);
            localStorage.setItem("parentId", data.parentId?.toString() || "");

            // ========================================================
            if (data.role === "ROLE_EMPLOYEE") {
                localStorage.setItem("vendorId", data.parentId?.toString() || "");
                localStorage.setItem("employeeId", data.vendorId?.toString() || "");
            } else {
                localStorage.setItem("vendorId", data.vendorId?.toString() || "");
            }

            if (data.businessModules && data.businessModules.length > 0) {
                localStorage.setItem("businessModules", JSON.stringify(data.businessModules));
            }
            if (data.subModules && data.subModules.length > 0) {
                localStorage.setItem("subModules", JSON.stringify(data.subModules));
            }

            localStorage.setItem("appTypes", JSON.stringify(data.appTypes || []));
            localStorage.setItem("subscriptionStatus", data.subscriptionStatus || "");
            localStorage.setItem("username", data.username || loginObj.userName);
            localStorage.setItem("userType", data.userType || "");
            localStorage.setItem("loginResponse", JSON.stringify(data));

            // ============ 🔥 STORE SELECTED MODULES FROM SUBSCRIPTION ============
            let selectedModules = [];
            let orderTypesList = [];

            if (data.subscriptions && data.subscriptions.length > 0) {
                const subscription = data.subscriptions[0];
                selectedModules = subscription.selectedModules || [];
                // 🔥 GET APP TYPE
                const appType = subscription.appType;

                localStorage.setItem("businessVertical", appType);

                // optional (array format if needed)
                localStorage.setItem("businessVerticals", JSON.stringify([appType]));
                // Store full subscription
                localStorage.setItem("subscription", JSON.stringify(subscription));
                localStorage.setItem("activeSubscription", JSON.stringify(subscription));

                // Store selectedModules separately
                if (selectedModules.length > 0) {
                    localStorage.setItem("selectedModules", JSON.stringify(selectedModules));

                    // 🔥 Filter order types from selectedModules
                    const validOrderTypes = ["DINE_IN", "TAKEAWAY", "CATERING", "DELIVERY", "TABLE_DINE_IN", "TABLE_ORDERS"];
                    orderTypesList = selectedModules.filter(module => validOrderTypes.includes(module));

                    if (orderTypesList.length > 0) {
                        localStorage.setItem("orderTypes", JSON.stringify(orderTypesList));
                    }
                }
            }

            // ============ STORE COMPLETE USER DATA ============
            const userData = {
                vendorId: data.role === "ROLE_EMPLOYEE" ? data.parentId : data.vendorId,
                customerId: data.customerId,
                selectedModules: selectedModules,
                orderTypes: orderTypesList,
                role: data.role,
                token: data.token,
                refreshToken: data.refreshToken,
                username: data.username || loginObj.userName,
                subscriptionStatus: data.subscriptionStatus || ""
            };
            localStorage.setItem("userData", JSON.stringify(userData));

            // ============ BANNER API ============
            const userRole = data.role;
            const authToken = data.token;

            let bannerVendorId;
            if (userRole === "ROLE_EMPLOYEE") {
                bannerVendorId = data.parentId;
            } else {
                bannerVendorId = data.vendorId;
            }

            try {
                const bannerResponse = await fetch(
                    `https://backend.maamaas.com/food/api/banner/${bannerVendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                if (bannerResponse.ok) {
                    const bannerData = await bannerResponse.json();

                    localStorage.setItem("companyName", bannerData.companyName || "");
                    localStorage.setItem("bannerData", JSON.stringify(bannerData));
                    localStorage.setItem("companyLogo", bannerData.companyLogo || "");
                    localStorage.setItem("companyBanner", bannerData.companyBanner || "");
                    localStorage.setItem("restaurantType", bannerData.Type || "");
                    localStorage.setItem("restaurantStatus", bannerData.RestaurentStatus ? "true" : "false");
                    localStorage.setItem("ratings", bannerData.Ratings?.toString() || "");
                    localStorage.setItem("fullAddress", bannerData.fullAddress || "");
                    localStorage.setItem("city", bannerData.city || "");
                    localStorage.setItem("state", bannerData.state || "");
                    localStorage.setItem("pincode", bannerData.pincode?.toString() || "");
                    localStorage.setItem("latitude", bannerData.latitude?.toString() || "");
                    localStorage.setItem("longitude", bannerData.longitude?.toString() || "");

                    // Banner API orderTypes (if available, use this instead)
                    if (bannerData.orderTypes && bannerData.orderTypes.length > 0) {
                        localStorage.setItem("orderTypes", JSON.stringify(bannerData.orderTypes));

                        // Update userData with banner orderTypes
                        const updatedUserData = JSON.parse(localStorage.getItem("userData") || "{}");
                        updatedUserData.orderTypes = bannerData.orderTypes;
                        localStorage.setItem("userData", JSON.stringify(updatedUserData));
                    }

                    localStorage.setItem("whatsappLink", bannerData.whatsappLink || "");
                    localStorage.setItem("instagramLink", bannerData.instagramLink || "");
                    localStorage.setItem("facebookLink", bannerData.facebookLink || "");
                    localStorage.setItem("twitterLink", bannerData.twitterLink || "");
                }
            } catch (bannerError) {
                // console.error("❌ Error fetching banner data:", bannerError);
            }

            // ============ NAVIGATION ============
            let redirectPath = "";

            if (userRole === "ROLE_EMPLOYEE") {
                const businessModules = data.businessModules || [];

                const moduleToRoute = {
                    "DASHBOARD": "/fooddashboard",
                    "BUSINESS_PROFILE": "/foodbeveragescompany",
                    "SETTINGS_CONTROLS": "/foodsettings",
                    "PRODUCTS_PRICES": "/foodandbeveragesMenu",
                    "ORDER_MANAGEMENT": "/foodordermanagment",
                    "CHEF_MANAGEMENT": "/foodchefmanagment",
                    "SERVICE_MANAGEMENT": "/fooddelivarymanagment",
                    "INVENTORY": "/foodandbeveragesInvetory",
                    "TEAM_MANAGEMENT": "/teammanagment",
                    "SALES_MANAGEMENT": "/salesmanagment",
                    "FINANCE_ACCOUNTING": "/foodAccuontdata",
                    "PROMOTIONS_MARKETING": "/foodandbeveragespromotions",
                    "REFER_EARN": "/referandearn",
                    "REWARDS_COUPONS": "/rewardslanding",
                    "RATINGS_REVIEWS": "/foodratings",
                    "HELP_DESK": "/foodandbeveragessupportsystem",
                    "LEGAL_COMPLIANCE": "/foodsupportsystem",
                    "NOTIFICATIONS": "/notificationcontext",
                    "REPORTS_ANALYSIS": "/foodandreporanalysis",
                };

                const firstModule = businessModules[0];
                if (firstModule && moduleToRoute[firstModule]) {
                    redirectPath = moduleToRoute[firstModule];
                } else {
                    redirectPath = "/fooddashboard";
                }
            } else {
                redirectPath = "/fooddashboard";
            }

            navigate(redirectPath);

        } catch (err) {
            // console.error("❌ Login error:", err);
            setError("Login failed: " + err.message);
        } finally {
            setIsLoading(false);
        }
    };
    const formattedBanners = useMemo(() => {
        return banners.flatMap((item) => {
            return [
                item.banner,
                item.image1,
                item.image2,
                item.image3,
                item.image4
            ]
                .filter(Boolean)
                .map((img) => ({
                    image: img,
                    companyName: item.companyName,
                    description: item.description
                }));
        });
    }, [banners]);

    useEffect(() => {
        fetchBanners();
    }, []);

    const fetchBanners = async () => {
        try {
            const res = await axios.get(
                "https://backend.maamaas.com/food/api/admin-banner/all"
            );
            setBanners(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            // console.error("Error fetching banners:", error);
        }
    };

    // ✅ AUTO SLIDE - FIXED
    useEffect(() => {
        if (formattedBanners.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) =>
                prev >= formattedBanners.length - 1 ? 0 : prev + 1
            );
        }, 3000);

        return () => clearInterval(interval);
    }, [formattedBanners.length]);

    return (
        <div className={`hero-container`} ref={containerRef}>
            {/* NAVBAR */}
            <nav className={`navbar ${navVisible ? "navbar-scrolled" : ""}`}>
                <div className="logo">
                    <span className="logo-box">MAAMAAS</span>
                </div>

                {/* Desktop Navigation Links */}
                <ul className={`nav-links ${isMobile ? 'mobile-hidden' : ''}`}>
                    <li onClick={() => scrollToSection(homeRef)}>Home</li>
                    <li onClick={() => scrollToSection(platformRef)}>Platform</li>
                    <li onClick={() => scrollToSection(coreservicesRef)}>Features</li>
                    <li onClick={() => scrollToSection(industriesRef)}>Empowerment</li>

                    <li onClick={() => scrollToSection(subscriptionRef)}>Subscription</li>
                </ul>

                {/* Desktop Actions */}
                <div className={`nav-actions ${isMobile ? 'mobile-hidden' : ''}`}>
                    <span className="signup-btn" onClick={() => setShowLogin(true)}>
                        Sign In
                    </span>
                    <span className="signup-btn" onClick={() => setIsDemoOpen(true)}>
                        Explore
                    </span>
                </div>

                {/* Mobile Hamburger Button */}
                {isMobile && (
                    <div className="hamburger-menu" onClick={() => setIsSidebarOpen(true)}>
                        <FaBars size={24} color={navVisible ? "#f44336" : "#fff"} />
                    </div>
                )}
            </nav>

            {/* Mobile Sidebar */}
            {isMobile && (
                <>
                    <div
                        className={`sidebar-overlay ${isSidebarOpen ? 'active' : ''}`}
                        onClick={() => setIsSidebarOpen(false)}
                    />
                    <div className={`mobile-sidebar ${isSidebarOpen ? 'active' : ''}`}>
                        <div className="sidebar-header">
                            <span className="sidebar-logo">MAAMAAS</span>
                            <FaTimes
                                className="sidebar-close"
                                onClick={() => setIsSidebarOpen(false)}
                                size={24}
                            />
                        </div>
                        <ul className="sidebar-nav-links">
                            <li onClick={() => scrollToSection(homeRef)}>Home</li>
                            <li onClick={() => scrollToSection(platformRef)}>Platform</li>
                            <li onClick={() => scrollToSection(industriesRef)}>Empowerment</li>
                            <li onClick={() => scrollToSection(coreservicesRef)}>Features</li>
                            <li onClick={() => scrollToSection(subscriptionRef)}>Subscription</li>
                        </ul>
                        <div className="sidebar-actions">
                            <span className="signup-btn" onClick={() => {
                                setShowLogin(true);
                                setIsSidebarOpen(false);
                            }}>
                                Sign In
                            </span>
                            <span className="signup-btn" onClick={() => {
                                setIsDemoOpen(true);
                                setIsSidebarOpen(false);
                            }}>
                                Explore
                            </span>
                        </div>
                    </div>
                </>
            )}

            {/* HERO SLIDER - FIXED */}
            <div className="hero-slider">
                <div
                    className="slider-track"
                    style={{
                        display: "flex",
                        transition: "transform 0.5s ease-in-out",
                        transform: `translateX(-${currentSlide * 100}%)`,
                        width: "100%",
                        height: "100%"
                    }}
                >
                    {formattedBanners.map((banner, index) => (
                        <div
                            key={index}
                            className="slide"
                            style={{
                                minWidth: "100%",
                                height: "100%",
                                backgroundImage: `url(${banner.image})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat"
                            }}
                        >
                            <div className="overlay">
                                <div className="hero-left">
                                    <h1>{banner.companyName}</h1>
                                    <p>{banner.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Dots Navigation */}
                {formattedBanners.length > 1 && (
                    <div className="slider-dots">
                        {formattedBanners.map((_, idx) => (
                            <button
                                key={idx}
                                className={`dot ${currentSlide === idx ? "active" : ""}`}
                                onClick={() => setCurrentSlide(idx)}
                            />
                        ))}
                    </div>
                )}

                {/* Loading State */}
                {formattedBanners.length === 0 && (
                    <p style={{ textAlign: "center", color: "#fff", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                        Loading...
                    </p>
                )}
                {/* <div className="pfb-wave-divider">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z"></path>
        </svg>
      </div> */}
            </div>



            {/* LOGIN MODAL */}
            {showLogin && (
                <>
                    <div
                        onClick={() => setShowLogin(false)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0,0,0,0.6)",
                            backdropFilter: "blur(6px)",
                            zIndex: 999,
                        }}
                    />
                    <div style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: "420px",
                        background: "#fff",
                        borderRadius: "16px",
                        padding: "30px",
                        zIndex: 1000,
                        boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
                        fontFamily: "Segoe UI"
                    }}>
                        <button
                            onClick={() => {
                                setShowLogin(false);
                                setIsForgot(false);
                            }}
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "15px",
                                border: "none",
                                background: "transparent",
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#888"
                            }}
                        >
                            ✕
                        </button>

                        <div style={{ textAlign: "center", marginBottom: "25px" }}>
                            <h2 style={{
                                fontWeight: "700",
                                fontSize: "26px",
                                background: "linear-gradient(135deg, #f44336, #f44336)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text"
                            }}>
                                Welcome Back
                            </h2>
                            <p style={{ fontSize: "14px", color: "#777" }}>
                                Login to continue
                            </p>
                        </div>

                        {!isForgot && (
                            <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                                <div style={{ position: "relative" }}>
                                    <FaUser style={iconStyle} />
                                    <input
                                        type="text"
                                        placeholder="Username / Email"
                                        name="userName"
                                        value={loginObj.userName}
                                        onChange={handleChanges}
                                        style={inputStyle}
                                    />
                                </div>

                                <div style={{ position: "relative" }}>
                                    <FaLock style={iconStyle} />
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        name="password"
                                        value={loginObj.password}
                                        onChange={handleChanges}
                                        style={{ ...inputStyle, paddingRight: "45px" }}
                                    />
                                    <span
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: "absolute",
                                            right: "15px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#777"
                                        }}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>

                                <div style={{ textAlign: "right" }}>
                                    <span
                                        onClick={() => setIsForgot(true)}
                                        style={{
                                            fontSize: "13px",
                                            color: "#667eea",
                                            cursor: "pointer",
                                            fontWeight: "500"
                                        }}
                                    >
                                        Forgot Password?
                                    </span>
                                </div>

                                {error && (
                                    <p style={{ color: "red", fontSize: "13px" }}>{error}</p>
                                )}

                                <button
                                    type="submit"
                                    style={{
                                        padding: "12px",
                                        borderRadius: "8px",
                                        border: "none",
                                        background: "linear-gradient(135deg, #f44336, #f44336)",
                                        color: "#fff",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                        boxShadow: "0 4px 15px rgba(102,126,234,0.3)"
                                    }}
                                >
                                    {isLoading ? "Logging in..." : "LOGIN"}
                                </button>
                            </form>
                        )}

                        {isForgot && (
                            <form onSubmit={handleResetPassword} style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                                <div style={{ position: "relative" }}>
                                    <FaEnvelope style={iconStyle} />
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        style={inputStyle}
                                    />
                                </div>

                                <button style={buttonStyle}>
                                    Reset Password
                                </button>

                                <button
                                    type="button"
                                    onClick={() => setIsForgot(false)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        color: "#667eea",
                                        cursor: "pointer"
                                    }}
                                >
                                    Back to Login
                                </button>
                            </form>
                        )}
                    </div>
                </>
            )}

            {isLoginModalOpen && (
                <div className="modal">
                    <div className="modal-box" style={{ top: "30%" }}>
                        <button className="modal-close" onClick={closeLoginModal}>
                            &times;
                        </button>
                        <h3 style={{ textAlign: "center" }}>
                            WELCOME TO MAAMAA'S
                        </h3>
                        <form onSubmit={handleEmailCheck}>
                            <input
                                type="email"
                                name="emailId"
                                placeholder="Enter your Email"
                                value={loginObj.emailId}
                                onChange={handleChanges}
                                required
                            />
                            <button type="submit">Check & Save</button>
                        </form>
                    </div>
                </div>
            )}

            {/* CONTENT SECTIONS */}
            <div ref={platformRef}>
                <CorePlatform />
            </div>
            <div ref={coreservicesRef}>
                <Coreservices />
            </div>

            <div ref={industriesRef}>
                <Digitalpresence />
            </div>

            <div style={{ background: "#fff" }} ref={industriesRef}>
                <Maamaasbusiness openDemo={() => setIsDemoOpen(true)} />
            </div>

            <div ref={aiRef}>
                <OrderTypes />
            </div>

            <div ref={subscriptionRef}>
                <PricingSection openDemo={() => setIsDemoOpen(true)} />
            </div>

            <div ref={faqRef}>
                <CTASection
                    isOpen={isDemoOpen}
                    onClose={() => setIsDemoOpen(false)}
                />
            </div>

            <div style={{ background: "#fff" }}>
                <Footerdata />
            </div>
        </div>
    );
}

const btnStyle = {
    width: "100%",
    padding: "12px",
    background: "red",
    color: "#fff",
    border: "none",
    borderRadius: "6px"
};

const inputStyle = {
    width: "100%",
    padding: "12px 15px 12px 40px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none",
    transition: "0.3s",
    color: "#000"
};

const iconStyle = {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#999",
    fontSize: "14px"
};

const buttonStyle = {
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "rgb(244 67 54)",
    color: "#fff",
    fontWeight: "600",
    cursor: "pointer"
};